export function consoleGrouped(title: string, objectFactory: () => any): void {
  consoleGroupCollapsed(title);
  consoleDir(objectFactory());
  consoleGroupEnd();
}

export function consoleLog(message: string): void {
  console.log(message);
}

export function consoleDir(object: any): void {
  console.dir(object);
}

export function consoleGroupCollapsed(label: string): void {
  console.groupCollapsed(label);
}

export function consoleGroupEnd(): void {
  console.groupEnd();
}
